module.exports = __webpack_public_path__ + "static/media/whychooseus.3eeedabb.png";